<template>
  <div id="app clear-fix">
    <div v-if="$route.name != 'FullScreen' && $route.name != null && $route.name != 'LoginPage'">
      <!-- 左侧导航�?-->
      <div class="left-content">
        <LeftNavBar v-if="!isMobile" />
      </div>

      <!-- 主内�?-->
      <div class="right-content clearfix">
        <!-- 上方登录信息 -->
        <top-nav></top-nav>
        <div class="main">
          <div class="dataview" :class="{ 'mobile-dataview': isMobile }">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>

    <!-- 大屏专用 -->
    <router-view v-else></router-view>
  </div>
</template>

<script>
import LeftNavBar from "@/components/pc/left_nav_bar/LeftNavBar.vue";
import TopNav from "@/components/pc/top_nav/TopNav.vue";

export default {
  name: "App",
  components: {
    TopNav,
    LeftNavBar,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    userAgent() {
      return navigator.userAgent;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  created() {
    this.$store.commit("setLoading", true);
  },
  mounted() {
    // setTimeout(() => {
    //   this.$store.commit("setLoading", false);
    // }, 2400);
    
    this.$store.commit("setWindowWidth", document.body.clientWidth);

    window.onresize = () => {
      return (() => {
        this.$store.commit("setWindowWidth", document.body.clientWidth);
      })();
    };
  },
  methods: {
    judgeMobileOrPC(userAgent) {
      if(userAgent.match( /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i )) {
        this.$store.commit("setIsMobile", true);
        // alert("手机端访�?);
      } else {
        this.$store.commit("setIsMobile", false);
        // alert("PC端访�?);
      }
    },
  },
  watch: {
    userAgent: {
      immediate: true,
      handler: function (nV, oV) {
        console.log("访问的端为：", navigator.userAgent);
        this.judgeMobileOrPC(nV);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
#app {
  width: 100%;
  min-width: 1200px;
  height: 200vh;
  overflow-y: scroll;
  display: flex;
  flex-direction: row;
  // .left-content {
  //   width: 100px !important;
  // }
  // .right-content {
  //   float: right;
  //   height: 100%;
  // }
}

// 手机端样�?
// .mobile-dataview {
//   min-width: 0px !important;
//   width: 100% !important;
// }
@import "./assets/css/base.css";
@import "./assets/icon/font.css";
</style>

